@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.settings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mifos_mobile.feature.settings.generated.resources/"

internal val Res.drawable.ic_baseline_dark_mode_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_baseline_dark_mode_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_baseline_dark_mode_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_help_mail: DrawableResource by lazy {
      DrawableResource("drawable:ic_help_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_help_mail.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_help_mobile: DrawableResource by lazy {
      DrawableResource("drawable:ic_help_mobile", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_help_mobile.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_icon_money_transfer: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_money_transfer", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_money_transfer.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_lock_black_24dp: DrawableResource by lazy {
      DrawableResource("drawable:ic_lock_black_24dp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_lock_black_24dp.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_passcode: DrawableResource by lazy {
      DrawableResource("drawable:ic_passcode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_passcode.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_translate: DrawableResource by lazy {
      DrawableResource("drawable:ic_translate", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_translate.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_update: DrawableResource by lazy {
      DrawableResource("drawable:ic_update", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_update.xml", -1, -1),
      ))
    }

internal val Res.drawable.mifo_app_info_icon: DrawableResource by lazy {
      DrawableResource("drawable:mifo_app_info_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/mifo_app_info_icon.png", -1, -1),
      ))
    }

internal val Res.drawable.mifos_icon: DrawableResource by lazy {
      DrawableResource("drawable:mifos_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/mifos_icon.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_baseline_dark_mode_24", Res.drawable.ic_baseline_dark_mode_24)
  map.put("ic_help_mail", Res.drawable.ic_help_mail)
  map.put("ic_help_mobile", Res.drawable.ic_help_mobile)
  map.put("ic_icon_money_transfer", Res.drawable.ic_icon_money_transfer)
  map.put("ic_lock_black_24dp", Res.drawable.ic_lock_black_24dp)
  map.put("ic_passcode", Res.drawable.ic_passcode)
  map.put("ic_translate", Res.drawable.ic_translate)
  map.put("ic_update", Res.drawable.ic_update)
  map.put("mifo_app_info_icon", Res.drawable.mifo_app_info_icon)
  map.put("mifos_icon", Res.drawable.mifos_icon)
}
